var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.077,
    height: 30.992,
    viewBox: "0 0 31.077 30.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IA_logo-20",
    "data-name": "IA logo-20",
    transform: "translate(-28.503 -19.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45376",
    "data-name": "Path 45376",
    d: "M41.079,19.159q3.121,2.418,6.246,4.83c.048.037.113.06.115.137-.016.031-.031.061-.046.093q-1.311,2.73-2.623,5.469c-.061.128-.094.208-.257.081q-3.046-2.363-6.1-4.714c-.3-.229-.248-.16-.1-.46l2.573-5.361C40.928,19.14,40.946,19.055,41.079,19.159Zm-3.516,7.064.117.091,4.905,3.78c.41.317.811.65,1.237.947.188.137.188.236.1.422-.438.9-.864,1.8-1.3,2.7q-1.358,2.821-2.715,5.653-1.429,2.978-2.867,5.954-.99,2.06-1.971,4.123c-.076.161-.124.21-.3.076q-3.061-2.378-6.144-4.735a.225.225,0,0,1-.085-.336q1.212-2.5,2.407-5l4.225-8.785q1.136-2.37,2.279-4.739C37.482,26.317,37.5,26.25,37.564,26.222Zm11.131.535L59.58,50.1c-.374-.194-.7-.362-1.027-.534l-6-3.169-7.719-4.078q-1.376-.726-2.754-1.447c-.119-.063-.137-.106-.075-.229q2.321-4.833,4.63-9.669.967-2.019,1.94-4.037A.41.41,0,0,1,48.695,26.758Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoText);
export default __webpack_public_path__ + "static/media/logo_no_text.548955b983a6fe31ef6cd00a39e0579d.svg";
export { ForwardRef as ReactComponent };